import bpmState from './bpm-state'
import { actions } from './bpm-actions'

export default (state = bpmState, action) => {
  switch (action.type) {
    case actions.RESET_STATE:
      return Object.assign({}, state, bpmState)
    case actions.SET_SEARCH_FILTER:
      return Object.assign({}, state, {
        searchFilter: action.value
      })
    case actions.SET_PROCESS_STEP_SEARCH_FILTER:
      return Object.assign({}, state, {
        processStepSearchFilter: action.value
      })
    case actions.SET_STEP_OPTION_SEARCH_FILTER:
      return Object.assign({}, state, {
        stepOptionSearchFilter: action.value
      })
    case actions.FETCH_ALL_DATA:
      return Object.assign({}, state, {
        data: action.payload
      })
    case actions.UPDATE_DATA:
      return Object.assign({}, state, {
        data: action.data
      })
    default:
      return state
  }
}
